import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { HR } from 'foundations-components/transitional/components/HR';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProfileReviewWizardHeader({
  name,
  logoUrl
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlock: "500",
      paddingInline: "800",
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: 2,
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            blockSize: "40px",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.profile.reviews.write.wizard.write"
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          size: 8,
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "row",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(Image, {
              alt: name,
              blockSize: "40px",
              responsive: false,
              src: logoUrl
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          size: 2
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "flush"
      })
    })]
  });
}